import React from 'react';
import {Looklet} from '../../model/constants/looklet';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {UIConstants} from '../../model/constants/uiConstants';


const RtOvwView = (props) => {
    const  stateToClass = (state) => {
        switch(state) {
            case Looklet.ViewState.APPROVED: return 'approved';
            case Looklet.ViewState.COMPLETED: return 'completed';
            case Looklet.ViewState.RECALLED: return 'recalled';
            case Looklet.ViewState.AWAITING_RETOUCH: return 'awaiting';
            case Looklet.ViewState.RETOUCH_CHECK_OUT: return 'checked-out';
            case Looklet.ViewState.REJECTED_RETOUCH: return 'rejected';
            case Looklet.ViewState.PRE_PROCESSING_CHECK_OUT: return 'prepro-checked-out';
            default:
                return '';
        }
    };
    const getDisplayClass = (base) => [base,base+'--'+props.displayMode];

    const view = props.view;
    // TODO: Make these constants
    let state = view.get('state');
    let type = view.get('type');
    let score = view.get('score');
    const getStyle = () =>
        props.displayMode===UIConstants.RT_OVW_COMPACT
            ? {height:type === Looklet.DisplayType.FABRIC_DETAIL ? 3 : 6 * score + 'px'}
            :{};
    const classes = getDisplayClass("rt-ovw__view");
    classes.push("rt-ovw__view--" + stateToClass(state))
    classes.push(type);
    return (
        <div className={classes.join(' ')}
             style={getStyle()}>&nbsp;
        </div>
    )
}
RtOvwView.propTypes = {
    view:ImmutablePropTypes.map.isRequired,
    displayMode:React.PropTypes.string.isRequired,
};

export default RtOvwView;




// WEBPACK FOOTER //
// ./src/ui/components/RtOvwView.js